<mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;" class="card-grid-border">
    <!-- <mat-card-header>
        <span style="margin-left: 0px;margin-top:20px;"  class="lanai-page-title">spACE Parking Agreement</span>
      </mat-card-header>     -->
    <mat-card-content>
        <div style="margin-top:15px;margin-bottom:35px;">
            
            @if(currentParkingAgreementStatus == status_agreementSigned){
                <span style="font-weight: bold;font-size:16px;color:green" matTooltip="This is the name that the Parker entered when the agreement was digitally signed">The agreement was signed by {{currentParkingAgreement.parkerAgreementNameEntered}} on {{currentParkingAgreement.dateAgreementAcknowledged| date:'shortDate'}}</span>
                <br />
                <a style="margin-left:10px;font-size:16px;text-decoration: underline;;"  mat-button (click)="onSendParkerSignedAgreement()" target="_blank">Email Signed Copy</a>
            }
            @else if(currentParkingAgreementStatus == status_agreementEmailSent) {
                <span style="font-weight: bold;font-size:16px;">The agreement was sent to the Parker on {{currentParkingAgreement.originalNotificationDateSent | date:'shortDate'}}, but the Parker HAS NOT signed the agreement yet.</span>
            }
            @else if(currentParkingAgreementStatus == status_agreementNotificationFailed) {
                <span style="font-weight: bold;font-size:16px;">The email failed while sending to Parker.  Please try again.</span>
            }
            @else if(currentParkingAgreementStatus == status_agreementExempt) {
                <span style="font-weight: bold;font-size:16px;">This Parker has been designated exempt from the Parking Agreement.</span>
            }
            @else if(currentParkingAgreementStatus == status_agreementRemovedFromExemptAndEmailSent) {
                <span style="font-weight: bold;font-size:16px;">This Parker was removed from exempt status and an Email has been sent to the Parker.</span>
            }
            @else if(currentParkingAgreementStatus == status_agreementExpired) {
                <span style="font-weight: bold;font-size:16px;">The Parking Agreement sent to this Parker has expired.</span>
            }
            @else if(currentParkingAgreementStatus == status_agreementParkerTermed) {
                <span style="font-weight: bold;font-size:16px;">This Parker has been termed and any agreement is invalid.</span>
            }
            @else if(currentParkingAgreementStatus == status_agreementViewedButNotSigned) {
                <span style="font-weight: bold;font-size:16px;">This Parker has viewed the Parking Agreement but HAS NOT signed it yet.</span>
            }
            @else if(currentParkingAgreementStatus == status_agreementResent) {
                <span style="font-weight: bold;font-size:16px;">The Parking Agreement has been resent to the Parker.</span>
            }
            @else if(currentParkingAgreementStatus == status_agreementNotSentOrExempt) {
                <span style="font-weight: bold;font-size:16px;">The Parking Agreement HAS NOT been sent and is NOT exempt.</span>
            }
            @else if(currentParkingAgreementStatus == status_agreementExemptRemoved) {
                <span style="font-weight: bold;font-size:16px;">The Parking Agreement has been removed from an exempt status.  A Parking Agreement email has NOT been sent to the Parker.</span>
            }
            @else {
                <span style="font-weight: bold;font-size:16px;">An unknown error has occurred and the Parking Agreement status cannot be determined</span>
            }

            <!-- 20241021 :: Ken Moss - removed per Josh Izigzon -->
            <!-- @if(parkingAgreementExists && this.currentParkingAgreement.agreementLink != '00000000-0000-0000-0000-000000000000'){
            <br />
            <span style="margin-left:10px;font-size:16px;">Copy Link to Parking Agreement</span>
            <button mat-icon-button aria-label="Copy Parker Id" [cdkCopyToClipboard]="parkingAgreementCopyUrl"  matTooltip="Copy Parker Parking Agreement URL"  (click)="onCopyMessage('Parking Agreement URL copied to clipboard')">
                <mat-icon>content_copy</mat-icon>
            </button>
            } -->


          
        </div>

        <ng-container style="margin-top:30px;" *ngIf="!isExempt">
            
            @if(currentParkingAgreementStatus != status_agreementSigned){
                <span style="margin-left: 0px;margin-top:20px;font-size:16px;font-weight: bold;">Send Parking Agreement</span>
           <form 
           style="margin-top:20px;"
            (ngSubmit)="onSubmitSendNotification()" 
            novalidate
            [formGroup]="parkerNotificationForm" >
                <div class="row margin-top:20px;">
                    <div class="col-6">
                        <mat-form-field appearance="fill" style="width:100%">
                            <mat-label>Send Agreement Notification Email</mat-label>
                            <input matInput placeholder="spACE Email Address" autocomplete="chrome-off" readonly="true" formControlName="emailAddress"    (keydown)="onKeyDown($event)">
                            <mat-icon matSuffix class="mimic-button-hover" (click)="confirmUpdateEmailAddress()" matTooltip="Edit Email Address">mode_edit</mat-icon>
                        </mat-form-field>
                    </div>
                    <div class="col-3">
                        <mat-form-field appearance="fill" style="width:100%">
                            <mat-label>Original Email Date</mat-label>
                            <input matInput placeholder="Original Email Date" autocomplete="chrome-off" readonly="true" formControlName="dateLastModified">
                        </mat-form-field>
                    </div>
                    <div class="col-3">
                        <mat-form-field appearance="fill" style="width:100%">
                            <mat-label>Resent Email Date</mat-label>
                            <input matInput placeholder="Resent Email Date" autocomplete="chrome-off" readonly="true" formControlName="dateEmailResent">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row margin-top:20px;">
                    <div class="col-4">
                        <div style="margin-top:0px;">
                            <mat-checkbox formControlName="linkInviteForm" color="secondary">Include Link to Request Parker Address/Vehicle Info</mat-checkbox>
                        </div>
                    </div>
                    <div class="col-4">
                        <!-- @if(this.lotParkingAgreementSettings.includeSpecialInstructions){ -->
                        <div style="margin-top:5px;">
                            <mat-checkbox formControlName="includeSpecialInstructions" color="secondary">Include Special Instructions Link URL</mat-checkbox>
                        </div>
                        <!-- } -->
                    </div>
                </div>
                @if(currentParkingAgreementStatus != status_agreementSigned){
                    <button type="submit" class="btn btn-primary mt-3" style="margin-left:5px;" [disabled]="!parkerNotificationForm.valid">{{sendInviteButtonText}}</button>
                }
            
            </form>
        }
        @else{
            <span style="margin-left: 0px;margin-top:20px;font-size:16px;font-weight: bold;">Signed Parking Agreement Details</span>
            <div>
            <span>This parker has signed a Monthly Parking Agreement and another invitation can no longer be sent.</span><br />
            <span>Included request for Address/Vehicle Information: <strong>@if(currentParkingAgreement.includeDataRequest){Yes}@else{No}</strong></span><br />
            <span>Included Special Instructions Link:<strong>@if(currentParkingAgreement.includeSpecialInstructions){Yes}@else{No}</strong></span><br />
            <span>Date First Email Sent: <strong>{{currentParkingAgreement.originalNotificationDateSent | date:'shortDate'}}</strong></span><br />
            @if((currentParkingAgreement.lastDateNotificationResend| date:'shortDate') != '1/1/01'){
                <span>Date Email Resent: <strong>{{currentParkingAgreement.lastDateNotificationResend| date:'shortDate'}}</strong></span><br />
            }
            @else {
                <span>Date Email Resent: <strong>--</strong></span><br />
            }
            

            </div>
        }
        </ng-container>

        <hr style="margin-top:30px;margin-bottom:30px;"/>


        <ng-container *ngIf="currentParkingAgreementStatus == status_agreementSigned">
            <span>This parker has signed the Monthly Parking Agreement and cannot be designated exempt.</span>
        </ng-container>
        <ng-container *ngIf="currentParkingAgreementStatus != status_agreementSigned">
           
            <form 
            style="margin-top:20px;"
            (ngSubmit)="onSubmitExemptAgreement()" 
            novalidate
            [formGroup]="agreementExemptionForm" >
                <div class="row margin-top:20px;">
                    <div class="col-3">
                        <mat-checkbox formControlName="isExempt" color="secondary" (click)="onValidateAgreementExempt()">Exempt from Agreement</mat-checkbox>
                    </div>
                </div>
                    <div class="row margin-top:15px;">
                    <div class="col-12 mt-3">
                        <mat-form-field appearance="fill" style="width:100%">
                            <mat-label>Comments for Exemption</mat-label>
                            <textarea matInput placeholder="Comments for Exemption" formControlName="exemptComments"  maxlength="500"  class="font-size-normal"  (keydown)="onKeyDown($event)" (input)="onValidateAgreementExempt()"></textarea>
                            <mat-error>Please enter a reason for the exemption</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <button type="submit" class="btn btn-primary mt-3" style="margin-left:5px;" [disabled]="!agreementExemptionForm.valid">Change Exemption Status</button>
            </form>
        </ng-container>
    </mat-card-content>
    <mat-card-actions style="margin-top:20px;">
    </mat-card-actions>
</mat-card>

